export default __webpack_public_path__ + "static/media/img_base_rose.d9c8e328.jpg";